// extracted by mini-css-extract-plugin
export var addressFields = "_nq-0";
export var animationContainer = "_nq-1";
export var footer = "_nq-2";
export var lineItems = "_nq-3";
export var modalContent = "_nq-4";
export var orderName = "_nq-5";
export var strong = "_nq-6";
export var warning = "_nq-7";